import React from 'react';
import LegacyBreadcrumbAdapter from '@atlassian/jira-breadcrumbs/src/legacy-breadcrumb-adapter/index.tsx';

export const BreadcrumbAdapter = () => {
	return <LegacyBreadcrumbAdapter />;
};
